import { type FC } from 'react'

export const FeedbackSkeletonPage: FC = () => null
